
import {getImageOfSize, getPostThumbnailAttributes} from "@/utils/getImagePaths.js";

export default {
  name: "PostOverviewItem",
  props: {
    post: Object,
    postType: String,
  },
  computed: {
    thumbnailAttributes() {
      return getPostThumbnailAttributes(this.post);
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    getImageOfSize,
    initAnimation() {
      if (this.$refs.link && this.$refs.link.$el) {
        this.$refs.link.$el.addEventListener('mouseenter', this.zoomIn);
        this.$refs.link.$el.addEventListener('touchstart', this.zoomIn);
        this.$refs.link.$el.addEventListener('mouseleave', this.zoomOut);
        this.$refs.link.$el.addEventListener('touchend', this.zoomOut);
      }
    },
    zoomIn() {
      const image = this.$refs.link.$el.querySelector('img');

      this.isActive = true;
      this.$gsap.killTweensOf(image);
      this.$gsap.to(image, {
        duration: 2,
        ease: "power4",
        scale: 1.1,
      });
    },
    zoomOut() {
      if (!this.$refs.link) return;
      const image = this.$refs.link.$el.querySelector('img');

      this.isActive = false;
      this.$gsap.killTweensOf(image);
      this.$gsap.to(image, {
        duration: 0.7,
        ease: 'expo',
        scale: 1
      });
    }
  },
}
